import * as React from 'react';

import {Button} from 'shells/button/button';
import {ButtonGroup} from 'shells/button-group/button-group';
// @ts-expect-error - imported from .js/.jsx file
import {AddIcon} from 'shells/icon/svg/add-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from 'shells/icon/svg/checkmark-icon';

import styles from './transcript-summary.module.css';

type Props = {
    onAdd: () => Promise<any>;
    onReplace: () => Promise<any> | null | undefined;
    onCancel: () => void;
};

export function SummaryButtons(props: Props) {
    return (
        <div className={styles.buttons}>
            <ButtonGroup>
                <Button
                    variant='ai-blue'
                    icon={AddIcon}
                    onClick={(e: React.SyntheticEvent<any>) => {
                        e.stopPropagation();
                        props.onAdd();
                    }}
                    tooltipText='Add to activity note'
                >
                    Add
                </Button>
                {props.onReplace ? (
                    <Button
                        variant='ai-blue'
                        icon={CheckmarkIcon}
                        onClick={(e: React.SyntheticEvent<any>) => {
                            e.stopPropagation();
                            props.onReplace();
                        }}
                        tooltipText='Replace activity note'
                    >
                        Replace
                    </Button>
                ) : undefined}
                <Button
                    onClick={(e: React.SyntheticEvent<any>) => {
                        e.stopPropagation();
                        props.onCancel();
                    }}
                >
                    Cancel
                </Button>
            </ButtonGroup>
        </div>
    );
}
